export const ROUTE_ENDPOINTS = {
  LOGIN: "/login",
  HOME: "/home",
};

export const ROUTE_NEW = "new";
